import { toastConstant } from 'constants/toastmessage';
import { COMPLETION_TOAST_MESSAGE, IN_PROGRESS_TOAST_MESSAGE } from 'modules/cases/medicalChronology/hooks/useChronologyWebSocket';

const WS_EVENT_TYPE = 'medical_chronology_update';

/**
 * One-shot File Manager listener for MedChron compilation terminal events.
 * Shows the same success/failure toasts as Sources (`useChronologyWebSocket`).
 *
 * @param {string} chronologyId
 * @param {{ subscribe: Function, unsubscribe: Function, addToast: Function }} deps
 * @returns {() => void} cleanup
 */
export const subscribeMedChronCompilationToasts = (chronologyId, { subscribe, unsubscribe, addToast }) => {
  if (!chronologyId || !subscribe || !unsubscribe || !addToast) {
    return () => {};
  }

  const handler = (data) => {
    const { event, chronology_id: incomingId, data: eventData } = data?.body ?? {};
    const resolvedChronologyId = incomingId ?? eventData?.chronology_id;
    if (resolvedChronologyId !== chronologyId) return;

    if (event === 'chronology_compilation_complete') {
      addToast(false, toastConstant.toasterType.SUCCESS, 'Success', COMPLETION_TOAST_MESSAGE);
      unsubscribe(WS_EVENT_TYPE, handler);
      return;
    }

    if (event === 'compilation_failed') {
      addToast(false, toastConstant.toasterType.ERROR, 'Error', eventData?.message || 'Compilation failed.');
      unsubscribe(WS_EVENT_TYPE, handler);
    }
  };

  subscribe(WS_EVENT_TYPE, handler);
  return () => unsubscribe(WS_EVENT_TYPE, handler);
};

export { IN_PROGRESS_TOAST_MESSAGE, COMPLETION_TOAST_MESSAGE };
